import React, { useState } from 'react';

import clsx from 'clsx';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as classes from './DeleteCoreEntityModal.module.css';

const DeleteCoreEntityModal = ({
    entity,
    entityCount,
    handleDeleteEntity,
    toggleModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            await handleDeleteEntity();
            setIsLoading(false);
            toggleModalOpen(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    return (
        <BobModal
            title={`Delete ${entity.type}`}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => toggleModalOpen(false)}
        >
            <div className={classes.Text}>
                <span className={clsx('material-icons-outlined md-24', classes.Icon)}>
                    info
                </span>
                <span className={classes.Font}>
                    {`Are you sure you want to delete the ${entity.type} below?`}
                </span>
            </div>
            <div className={classes.EntityContainer}>
                <div className={classes.Label}>
                    {entity.type}
                </div>
                <div className={classes.Value}>
                    {entity.name}
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                <BobCancelButton
                    onClick={() => toggleModalOpen(false)}
                    className={classes.CancelButton}
                    label={'Cancel'}
                />
                <BobConfirmButton
                    onClick={() => handleDelete()}
                    className={classes.Buttons}
                    label={'Delete'}
                    iconSize={15}
                    isLoading={isLoading}
                />
            </div>
        </BobModal>
    );
};

export default DeleteCoreEntityModal;
